<template>
  <ResetPassword data-fn-location="reset-password"/>
</template>

<script>
import ResetPassword from '../components/templates/ResetPassword'

export default {
  components: {
    ResetPassword
  }
}
</script>
